import {api} from './api';

export interface MemoryBlockItem {
    id: number;
    name: string;
    description?: string;
    sort?: number;
    status?: number;
    createdTime?: string;
    updatedTime?: string;
}

export interface MemoryItem {
    id: number;
    /**
     * 产生者/私有归属智能体配置ID
     */
    agentConfigId?: number;
    /**
     * 共享记忆块ID（空=私有记忆）
     */
    blockId?: number;
    blockName?: string;
    content: string;
    status: number;
    source: number;
    createdTime?: string;
    updatedTime?: string;
}

export interface MemoryVerifyItem {
    memoryId: number;
    content: string;
    blockId?: number;
    blockName?: string;
    status: number;
    source: number;
    similarity: number;
}

export const memoryService = {
    // ==================== 共享记忆块 ====================
    async listBlocks(): Promise<MemoryBlockItem[]> {
        const response = await api.get('/api/memory-blocks');
        return response.data.data;
    },

    async createBlock(req: Partial<MemoryBlockItem>): Promise<MemoryBlockItem> {
        const response = await api.post('/api/memory-blocks', req);
        return response.data.data;
    },

    async updateBlock(id: number, req: Partial<MemoryBlockItem>): Promise<MemoryBlockItem> {
        const response = await api.put(`/api/memory-blocks/${id}`, req);
        return response.data.data;
    },

    async deleteBlock(id: number): Promise<string> {
        const response = await api.delete(`/api/memory-blocks/${id}`);
        return response.data.data;
    },

    // ==================== 记忆条目 ====================
    async listPrivateMemories(agentConfigId: number): Promise<MemoryItem[]> {
        const response = await api.get('/api/memory', {params: {agentConfigId}});
        return response.data.data;
    },

    async listBlockMemories(blockId: number): Promise<MemoryItem[]> {
        const response = await api.get('/api/memory', {params: {blockId}});
        return response.data.data;
    },

    async addPrivateMemory(agentConfigId: number, content: string): Promise<MemoryItem> {
        const response = await api.post('/api/memory', {agentConfigId, content});
        return response.data.data;
    },

    async addBlockMemory(blockId: number, content: string): Promise<MemoryItem> {
        const response = await api.post('/api/memory', {blockId, content});
        return response.data.data;
    },

    async approve(id: number): Promise<MemoryItem> {
        const response = await api.post(`/api/memory/${id}/approve`);
        return response.data.data;
    },

    async reject(id: number): Promise<MemoryItem> {
        const response = await api.post(`/api/memory/${id}/reject`);
        return response.data.data;
    },

    async disable(id: number): Promise<MemoryItem> {
        const response = await api.post(`/api/memory/${id}/disable`);
        return response.data.data;
    },

    async deleteMemory(id: number): Promise<string> {
        const response = await api.delete(`/api/memory/${id}`);
        return response.data.data;
    },

    async verify(req: {
        agentConfigId?: number;
        blockId?: number;
        query: string;
    }): Promise<MemoryVerifyItem[]> {
        const response = await api.post('/api/memory/verify', req);
        return response.data.data;
    },

    // ==================== 智能体绑定 ====================
    async listBoundBlockIds(agentConfigId: number): Promise<number[]> {
        const response = await api.get(`/api/memory/agent/${agentConfigId}/bound-blocks`);
        return response.data.data;
    },

    async bindBlocks(agentConfigId: number, blockIds: number[]): Promise<string> {
        const response = await api.post(`/api/memory/agent/${agentConfigId}/bind`, {blockIds});
        return response.data.data;
    },
};
